import {useEffect, useState} from 'react'
import { Header, Table, TableBody, TableCell, TableRow,Image,Dropdown,Input, TableHeader, TableHeaderCell, Icon, Button,Modal,ModalHeader,ModalDescription } from 'semantic-ui-react';
import {FrrInformationTitleDetails, TitleWiseDashboard,defectType,getfrrReportAddress} from '../../../../app/models/Restoration';
import { toast } from 'react-toastify';
import { useStore } from '../../../../app/stores/store';
import FRRreport  from "../PCRReport/FRReportPdfconvert";

interface PCRPDFComponentProps {
    rowdata: TitleWiseDashboard;
  }
function FRRReportGenerate({ rowdata }: PCRPDFComponentProps) {
    const { RestorationStore } = useStore();
   // const [outputFormat,setoutputFormat]=useState<string>('');
    //const [inputFormat,setinputFormat]=useState<string>('');
   // const [clientRequirementOptionValue,setclientRequirementOptionValue]=useState<string>('');
    //const [resolutionOptionValue,setResolutionOptionValue]=useState<string>('');
    const [FrrComments,setFrrComments]=useState<string>('');
    const [frrReelName,setfrrReelName]=useState<string>('');
    const [frrStartFrame,setfrrStartFrame]=useState<number>(0);
    const [frrEndFrame,setfrrEndFrame]=useState<number>(0);
    const [generalSummaryValue,setgeneralSummaryValue]=useState<string>('');
    //const [reelNumber,setreelNumber]=useState<string>('0');
    const [defectValue , setdefectValue]=useState<defectType[]>([]);
    const [frrAddressDetails,setfrrAddressDetails]=useState<getfrrReportAddress[]>([]);
    const [frrTitleDetails,setFrrTitleInformation]=useState<FrrInformationTitleDetails|null>(null);
    const [serialNoValue,setserialNoValue]=useState<number>(1);
    const [open, setOpen] = useState(false);
    const [confirmModelOpen,setconfirmModelOpen]= useState(false);
    const [extraComments, setextraComments]=useState<string>('');
    const goBack = () => {window.location.reload();};
    const[openFRRReport,setOpenFFRReport]= useState(false);
    const [tableData, setTableData] = useState([{ S_No: serialNoValue,addressNo:0,reelName:'',startFrame: 0,endFrame: 0,totalFrame: 0, comments: '',ClusterName:''},]);
    // const formatOption=[
    //     { key: 1, text: 'DPX', value: 'DPX' },
    //     { key: 2, text: 'TIFF', value: 'TIFF' },
    //     { key: 3, text: 'QT', value: 'QT' },
    //     { key: 4, text: 'Pro res', value: 'Pro res' }]
    //   const ClientRequirementOption=[
    //     { key: 1, text: 'LTO', value: 'LTO' },
    //     { key: 2, text: 'HD', value: 'HD' },
    //     { key: 3, text: 'UPLOAD', value: 'UPLOAD' },
    //     { key: 4, text: 'DMD Transfer', value: 'DMD Transfer' },
    //     { key: 5, text: 'DPX', value: 'DPX' },]
    //   const resolution=[
    //     { key: 1, text: '2048×1080', value: '2048×1080' },
    //     { key: 2, text: '4096×2160', value: '4096×2160' },
    //     { key: 3, text: '5120×2880', value: '5120×2880' },
    //     { key: 4, text: '7680×4320', value: '7680×4320' },]
        const addFrrcomment=async ()=>{
        if(frrEndFrame === null || FrrComments=== null ||  frrReelName === null || FrrComments === "")
            { toast.error('Please enter Valid Information');}
            else{
                try{
                    const Data = {
                        titleCode:rowdata.title_Code,
                        reelName:frrReelName,
                        startFrame:frrStartFrame,
                        endFrame:frrEndFrame,
                        totalFrame:(frrEndFrame-frrStartFrame)+1,
                        comments:FrrComments+' ,'+extraComments}
                        await RestorationStore.createFfraddress(Data);
                        loadFfrDetails();
                }
                catch{toast.error('Error fetching PCR comments');
                }
            }
        };

        const loadFfrDetails=async()=>{
        try{
            await RestorationStore.FrrGetandGenerateComments(rowdata.title_Code);
            setFrrTitleInformation(RestorationStore.FrrInformationTitle)
            await RestorationStore.getFfrAddress(rowdata.title_Code);
            setfrrAddressDetails(RestorationStore.getFrrReportAddress);
            setfrrReelName('');
            setfrrStartFrame(0);
            setfrrEndFrame(0);
            setdefectValue([]);
            setFrrComments('');
            setextraComments('')
            masterDefectDetails();
        }
        catch
        {
            toast.error('Some went wrong , Please try again');
        }
    }
const Confirmation=async()=>{
    setconfirmModelOpen(true);
}

    const frrReport=async()=>{
        
        try{const reportData={
                titleCode:rowdata.title_Code  ,
                inputFrame:frrTitleDetails?.input_Format ?? '',
                noOfReel:frrTitleDetails?.no_of_Reels?.toString() ?? '',
                outputFrame:frrTitleDetails?.out_Format ?? '',
                clientRequirementLevel:frrTitleDetails?.client_Requirement_Level_Requested ?? '',
                resolution:frrTitleDetails?.aspect_Ratio ?? '',
                generalSummary:generalSummaryValue,
            }
            await RestorationStore.createFrrDetails(reportData);
            setOpen(true);
            setOpenFFRReport(true);
            
        }
            catch{toast.success("FRR Report Not Updated");}
        
    }
   
    const deleteData=async(addressNo:number,reelName:string)=>
        {
           await RestorationStore.deleteFrrAddress(rowdata.title_Code,reelName,addressNo);
        }
    const masterDefectDetails = async () => {
        await RestorationStore.DefectInformation();
        await setdefectValue(RestorationStore.DefectTypesValue);
    }
    
    const handleRemoveRow = async (rowIndexToRemove: number) => {
      const updatedData = tableData.filter((row, index) => index !== rowIndexToRemove);
      const resetSNoData = updatedData.map((row, index) => {
        return { ...row, S_No: index + 1 };
    });
      await setTableData(resetSNoData);
      await setserialNoValue(tableData.length)
  };
      useEffect(()=>{
        loadFfrDetails();
         // eslint-disable-next-line 
      },[]);
      
      useEffect(()=>{
        
      if( frrAddressDetails.length>0)
            { 
                setTableData(
                frrAddressDetails.map((item, index) => ({
                S_No: index + 1,
                addressNo: item.addressNo,
                ClusterName:item.clusterName,
                reelName:item.reelName,
                startFrame: item.startFrame,
                endFrame: item.endFrame,
                totalFrame: item.totalFrame,
                comments: item.comments,
                })));
                setserialNoValue(frrAddressDetails.length+1);
            }
        else{
            setTableData([]);
        }
    },[frrAddressDetails])
 
  return (
   <>
    <div className='container mt-5 border p-5'>
        <Table className="ui unstackable table" style={{ border: '1px solid gray' }}>
                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={1} style={{textAlign: 'center'}}><br/><Image src={'../assets/PrasadCorp.jpg'} size='small' /></TableCell>
                            <TableCell colSpan={5} style={{textAlign: 'center'}}><br/><Header as='h2'>Final Restoration Report</Header><br/></TableCell>
                            <TableCell colSpan={2} style={{textAlign: 'center'}}></TableCell>
                        </TableRow>
                       
                        <TableRow>
                            <TableCell style={{ borderRight: '1px solid gray' }}><Header as='h4'>Title</Header></TableCell>
                            <TableCell colSpan={7}>{frrTitleDetails?.title_Name}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ borderRight: '1px solid gray' }}><Header as='h4'>Input Format</Header></TableCell>
                            <TableCell colSpan={7}>
                            {/* <Dropdown
                                placeholder='Input Format'
                                search
                                selection
                                options={formatOption}
                                defaultValue={formatOption[0].value}
                                onChange={(event,data:any)=>{
                                if(data.value!==undefined){
                                    setinputFormat(data.value);
                                }
                                }}
                            /> */}
                            {frrTitleDetails?.input_Format}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ borderRight: '1px solid gray' }}><Header as='h4'>Out Format</Header></TableCell>
                            <TableCell colSpan={7}>
                            {/* <Dropdown
                                placeholder='Out Format'
                                search
                                selection
                                options={formatOption}
                                defaultValue={formatOption[0].value}
                                onChange={(event,data:any)=>{
                                if(data.value!==undefined){
                                    setoutputFormat(data.value);
                                }
                                }}
                            /> */}
                            {frrTitleDetails?.out_Format}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ borderRight: '1px solid gray' }}><Header as='h4'>Client Requirement<br/>Level Requested</Header></TableCell>
                            <TableCell colSpan={7}>
                            {/* <Dropdown
                                placeholder='Client Requirement'
                                search
                                selection
                                options={ClientRequirementOption}
                                defaultValue={formatOption[0].value}
                                onChange={(event,data:any)=>{
                                if(data.value!==undefined){
                                    setclientRequirementOptionValue(data.value);
                                }
                                }}
                            /> */}
                             {frrTitleDetails?.client_Requirement_Level_Requested}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ borderRight: '1px solid gray' }}><Header as='h4'>Reels #</Header></TableCell>
                            <TableCell style={{ borderRight: '1px solid gray' }}>
                                {/* <Input type="number" placeholder="Please Enter General Summary" style={{ width: '50%', margin: 0, padding: 0 }} value={reelNumber} onChange={(event) => setreelNumber(event.target.value)}/> */}
                                {frrTitleDetails?.no_of_Reels}
                            </TableCell>
                            <TableCell style={{ borderRight: '1px solid gray' }}><Header as='h4'>Resolution</Header></TableCell>
                            <TableCell style={{ borderRight: '1px solid gray' }}>
                                
                            {/* <Dropdown
                                placeholder='Resolution'
                                search
                                selection
                                options={resolution}
                                defaultValue={formatOption[0].value}
                                onChange={(event,data:any)=>{
                                if(data.value!==undefined){
                                    setResolutionOptionValue(data.value);
                                }
                                }}
                            /> */}
                            {frrTitleDetails?.aspect_Ratio}
                                </TableCell>
                            <TableCell style={{ borderRight: '1px solid gray' }}><Header as='h4'>Total Frames</Header></TableCell>
                            <TableCell colSpan={3}>{rowdata.allocated_Frames}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={8} style={{ textAlign: 'center', color: 'purple' ,fontWeight:'bold'}} >General Summary</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={8}>
                                <Input type="text" placeholder="Please Enter General Summary" style={{ width: '100%', margin: 0, padding: 0 }} value={generalSummaryValue} onChange={(event) => setgeneralSummaryValue(event.target.value)}/>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={8}  style={{ textAlign: 'center', color: 'purple',fontWeight:'bold' }}>Addressing Details</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={8}>
                      <Table>
                        <TableHeader>
                          <TableRow>
                            <TableHeaderCell>S.No</TableHeaderCell>
                            <TableHeaderCell>Cluster Name</TableHeaderCell>
                            <TableHeaderCell>Reel Name</TableHeaderCell>
                            <TableHeaderCell>Start Frame</TableHeaderCell>
                            <TableHeaderCell>End Frame</TableHeaderCell>
                            <TableHeaderCell>Total Frames</TableHeaderCell>
                            <TableHeaderCell>Comments</TableHeaderCell>
                            <TableHeaderCell>Action</TableHeaderCell>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                        {tableData.length>0 && (tableData.map((row, index) => (
                            
                            <Table.Row key={index}>
                            {row.reelName!=='' && (
                            <>
                            <Table.Cell>{row.S_No}</Table.Cell>
                            <Table.Cell>{row.ClusterName}</Table.Cell>
                            <Table.Cell>{row.reelName}</Table.Cell>
                            <Table.Cell>{row.startFrame}</Table.Cell>
                            <Table.Cell>{row.endFrame} </Table.Cell>
                            <Table.Cell>{row.totalFrame}</Table.Cell>
                            <Table.Cell>{row.comments}</Table.Cell>
                            <Table.Cell><div className="ui buttons"><button className="ui red button" onClick={() => {handleRemoveRow(index);deleteData(row.addressNo,row.reelName)}}><Icon  className='trash'/></button></div></Table.Cell>
                            </>)} </Table.Row>)))}
                            <Table.Row>
                                <Table.Cell>{serialNoValue}</Table.Cell>
                                <Table.Cell><Input
                                    type="text"
                                    value={frrReelName}
                                    onChange={(e) => setfrrReelName(e.target.value)}/>
                                </Table.Cell>
                                <Table.Cell><Input
                                    type="number"
                                    min={0}
                                    value={frrStartFrame}
                                    onChange={(e) => {setfrrStartFrame(parseInt(e.target.value))}}
                                    />
                                </Table.Cell>
                                <Table.Cell><Input
                                    type="number"
                                    min={frrStartFrame}                                
                                    value={frrEndFrame}
                                    onChange={(e) => {setfrrEndFrame(parseInt(e.target.value));}}
                                    />
                                </Table.Cell>
                                <Table.Cell>
                                    <Input
                                        type="number"
                                        readOnly
                                        value={parseInt(frrEndFrame.toString()) - parseInt(frrStartFrame.toString()) + 1}
                                        
                                    />
                                </Table.Cell>
                                <Table.Cell>
                                    <Dropdown
                                        placeholder='Defect Type'
                                        multiple
                                        search
                                        selection
                                        options={defectValue}
                                        defaultValue='Select Value'
                                        onChange={(e: any, data: any) => { 
                                        const selectedValue = data.value.join(', '); 
                                        setFrrComments(selectedValue);}}/>
                                </Table.Cell>
                                <Table.Cell>
                                    <Input
                                    type="text"
                                    value={extraComments}
                                    onChange={(e) => setextraComments(e.target.value)}/>
                                </Table.Cell>
                                <Table.Cell><button className="ui positive button" onClick={addFrrcomment}><Icon  className='plus'/></button></Table.Cell>
                            </Table.Row>
                        </TableBody>
                            </Table>
                            </TableCell>
                        </TableRow>
                    </TableBody>
        </Table>
        <div style={{textAlign:'center'}}>
                <Button className='ui green button' onClick={Confirmation}>Save</Button>
                <Button className="ui button" onClick={goBack}>Cancel </Button>
        </div>
            <Modal open={open} onClose={() => setOpen(false)} onOpen={() => setOpen(true)} size={'fullscreen'}>
              <ModalHeader>
                <ModalDescription>
                {rowdata !== null && openFRRReport === true && 
                <FRRreport rowdata={rowdata}/>}
                </ModalDescription>
              </ModalHeader>
            </Modal>
                
             
    {confirmModelOpen && (
                <Modal open={confirmModelOpen}>
                <ModalHeader>
                <ModalDescription>
                <div>
                <p>Are you sure you want to proceed with updating the FRR Report?</p>
                <Button className='ui green button' onClick={frrReport}>OK</Button>
                <Button className="ui button" onClick={()=>setconfirmModelOpen(false)}>Cancel </Button>
                </div>
                </ModalDescription>
                </ModalHeader>
            </Modal>
             )}
    
    </div>   
    
   </>
   
  )
}

export default FRRReportGenerate